/*
 * @Author: LiuChuanQi
 * @Date: 2022-12-05 12:04:24
 * @LastEditTime: 2022-12-05 12:11:31
 * @LastEditors: LiuChuanQi
 * @Description: 信息脱敏
 * @FilePath: \speedtest-bigdata-v2\src\utils\hooks\tuoming.js
 * 
 */
/**
 *
 * 手机号脱敏处理
 */
export const noPassByPhone = (phone) => {
  return phone.substring(0, 3) + "****" + phone.substring(7)
}

/**
 *
 * 邮箱脱敏处理
 */
export const noPassByEmail = (email) => {
  let new_email = email
  if (String(email).indexOf('@') > 0) {
    let str = email.split('@')
    let _s = ''
    if (str[0].length > 3) { //@前面多于3位
      for (let i = 3; i < str[0].length; i++) {
        _s += '*'
      }
      new_email = str[0].substr(0, 3) + _s + '@' + str[1]
    } else { //@前面小于等于于3位
      for (let i = 1; i < str[0].length; i++) {
        _s += '*'
      }
      new_email = str[0].substr(0, 1) + _s + '@' + str[1]
    }
  }
  return new_email
}